// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,

  /*Variables del estilo/tema*/
  appDarkMode :false,          //--Modo oscuro o claro : true=Oscuro, false=Claro
  appHeaderInverse: false,    //--Aplica el tema inverso al header diferente o igual a appDarkMode
  appGradientEnabled : true,  //--Genera el gradien a partir del color primario
  appThemeDef : 'cyan',        //Colores diponible: red,pink,orange,yellow,lime,green,teal,cyan,blue,purple,indigo,gray-500

  //----------------------------------------------------------------------------------------------------------------------------------------

  /*Variables del menú*/
  appSidebarFixed : false,     //--Mantener bloqueado el menú lateral izquierdo
  appSidebarGrid :true,       //--Mostrar bordes del manú lateral izquierdo
  //--INICIO--Menú superior y lateral izquierdo - se recomienda utilizar uno de los dos
  appTopMenu :false,          //--Aplica un menú superior y los item se gestionan en AppMenuService (los cambios son aplicables al menú lateral izquierdo). true lo muestra
  appSidebarNone:false,       //--Aplica un menú lateral y los item se gestionan en AppMenuService (los cambios son aplicables al menú superior). true lo oculta
  //--INICIO--Menú superior y lateral izquierdo - se recomienda utilizar uno de los dos
  appSidebarEnd : false,      //--Coloca el menú lateral a la izquierda o derecha, true= derecha, false=izquierda.

  //----------------------------------------------------------------------------------------------------------------------------------------

  /*Variables del header*/
  appHeaderFixed  : false,     //--Mantener bloqueado el header

  //----------------------------------------------------------------------------------------------------------------------------------------

  /*Variables del otros menús*/
  appSidebarTwo_and_appSidebarEndToggled:false,   //Si es true, implementar el adordión del componente: SidebarRightComponent. 
  appHeaderMegaMenu: false,                       //Muestra un SuperMenú superior, se tiene que implementar el componente: HeaderComponent, pero tiene problemas con las propiedades: appTitleHeaderStrong y appSubTitleHeaderLight si es que los textos estan largos.

  /*Títulos principales y que pueden cambiar según la navegación*/
  appTitleHeaderStrong:'TWX',  //Titulo de mi template
  appSubTitleHeaderLight:'v1',            //SubTitulo de mi template (Este puede cambiar en la navegación, pero no se recomienda porque cada componente tendrá su master page)  
  appTitleSite:'TWX',                      //Titulo de la pestaña del sitio
  appMostrarNotificaciones:false,                     //Muestra la campanita de notificaciones, en caso de implementar se tiene que trabajar en el componente: HeaderComponent


  // base: 'http://13.65.44.107:',
  //base: 'http://developer.prodx.com.mx:',
  //local: 'http://localhost:',
  //catalogos_port: '7051/',
  //sat_port: '8052/',

   base: '',
   catalogos_port: 'https://twx-agw.prodx.com.mx/',
   sat_port: 'https://dev-gcis-agw.prodx.com.mx/',

  //base: '',
  //catalogos_port: 'https://qa-twx-agw.prodx.com.mx/',
  //sat_port: 'https://dev-gcis-agw.prodx.com.mx/',



  apikey: '2d1c7a28-33a0-443d-ba0d-747540f78ea7',
  apikeySat: 'e4c45fa3-7362-448e-ae2b-e0af66abb34a',
  jwt: '46ccc0d9-1886-40c6-946c-839286410b76'
};
